import { Component, OnInit, Input } from '@angular/core';

import { IndicatorComponent } from '@shared/core/components/indicators/indicator.shared.component';

@Component({
    selector: 'shared-order-id',
    templateUrl: './order-id.shared.component.html',
    styleUrls: ['./order-id.shared.component.scss']
})
export class OrderIdComponent extends IndicatorComponent implements OnInit {
    @Input() public title: string = 'ORDER';
    @Input() public orderId: string | number = null;
    @Input() public size: OLO.Components.INDICATOR_SIZE = 'xxxlg';
    @Input() public mobileSize: OLO.Components.INDICATOR_SIZE = null;
    @Input() public feel: OLO.Components.INDICATOR_FEEL = null;
    @Input() public inverted: boolean = true;

    constructor() {
        super();
    }

    ngOnInit(): void {
        if (this.mobileSize && window.innerWidth < 768) {
            this.size = this.mobileSize;
        }
    }
}
